module.exports = __webpack_public_path__ + "static/media/fig_12b.8f33c52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_12b.jpg
// module id = 632
// module chunks = 0